// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__kBKFN","filterTag":"styles_filterTag__WE2cR","selected":"styles_selected__Ys2ma"};